import { useEffect, useState, useRef } from "react";
import { Col, Row, Overlay, Button, Popover } from "react-bootstrap";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import { connect } from "react-redux";
import FormikControl from "../../../layouts/Input/FormikControl";
import { Formik, Form } from "formik";
import { Link } from "react-router-dom";
import { getDropdownList, getDropdownListByPost } from "../../Shared/dropdownListActions";
import {
  GET_DISTRIBUTOR_DDL,
  GET_ADDJOB_DISTRIBUTIONCENTER_DDL,
} from "../../../Types";
import { getDataListing, downloadJob } from "./BankWiseDepositReportActions";
import Moment from "react-moment";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import storage from "../../../apis/Storage";
import { isPermittedPage } from "../../../apis/Utility";
import { formatDate, toCommaSeparated } from "../../../utilities/FUNCTIONS";

const BankWiseDepositReport = (props) => {
  const userRights = JSON.parse(storage.get("_userRights"));

  const [target, setTarget] = useState(null);
  const [show, setShow] = useState(false);
  const ref = useRef(null);

  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);

  const [addJobDistributorsOptions, setAddJobDistributorsOptions] = useState([]);
  const [distCentersOptions, setDistCentersOptions] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [filter, setFilter] = useState({
    distributor: [],
    distCenter: [],
    fromDate: new Date(),
    toDate: new Date(),
    pageNo: 0,
    searchText: "",
    isExport: false,
  });

  const columns = [
    { Header: "Distributor", accessor: "distributor" },
    { Header: "Distribution Center", accessor: "distributionCenter" },
    { Header: "Deliveryman Name", accessor: "deliverymanName" },
    { Header: "Cash Collected", accessor: "cashCollected" },
    { Header: "Bank Deposit", accessor: "bankDeposit" },
    { Header: "Bank Name", accessor: "bankName" },
    { Header: "Slip No.", accessor: "despoitSlipNumber" },
    {
      Header: "Date",
      accessor: "depositDate",
      Cell: ({ value }) => <Moment format="DD/MM/YYYY">{value}</Moment>,
    },
  ];

  // -------------------- DATA FETCH -------------------- //
  useEffect(() => {
    props.getDropdownList("api/Distributor/GetDistributorsDDL", GET_DISTRIBUTOR_DDL);
  }, []);

  useEffect(() => {
    fetchReportData();
  }, [searchText]);

  // Distributor -> Distribution Center
  useEffect(() => {
    if (!filter.distributor || filter.distributor.length > 0) {
      props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
        { distributorIds: toCommaSeparated(filter.distributor) },
        GET_ADDJOB_DISTRIBUTIONCENTER_DDL
      );
      filter.distCenter = []; // reset DistributionID when Distributor changes
    } else {
      setDistCentersOptions([]);
      filter.distCenter = [];
    }
  }, [filter.distributor]);

  // Map Redux distributor list to dropdown
  useEffect(() => {
    //debugger;
    if (props.allDistributorList?.length) {
      if (userRights?.userType === "DistributorUser") {
        const filtered = props.allDistributorList.filter(
          (x) => x.value === userRights.distributorId
        );
        setAddJobDistributorsOptions(
          filtered.map((item) => ({ value: item.value, label: item.label }))
        );
      } else {
        setAddJobDistributorsOptions(
          props.allDistributorList.map((item) => ({ value: item.value, label: item.label }))
        );
      }
    }
  }, [props.allDistributorList]);

  useEffect(() => {
    if (props.selectedAddJobDistCentersList?.length) {
      let options = props.selectedAddJobDistCentersList.map((item) => ({
        value: item.value,
        label: item.label,
      }));

      // Apply DistributorUser restrictions if needed
      if (userRights?.userType === "DistributorUser" || userRights?.userType === "CoreAppUser") {
        const allowedIds = userRights.distCenterIds.split(",");
        options = options.filter((x) => allowedIds.includes(x.value));
      }

      setDistCentersOptions(options);
    } else {
      setDistCentersOptions([]);
    }
  }, [props.selectedAddJobDistCentersList, userRights]);

  // -------------------- FILTER REQUEST -------------------- //
  const formRequestObject = () => {
    const requestData = {
      distId: userRights?.userType === "DistributorUser" ? toCommaSeparated(userRights.distributorId) : toCommaSeparated(filter.distributor),
      distCenterId: toCommaSeparated(filter.distCenter),
      fromDate: filter.fromDate && formatDate(filter.fromDate),
      toDate: filter.toDate && formatDate(filter.toDate),
      pageSize: currentPageSize,
      pageNo: filter.pageNo,
      searchText: searchText,
      isExport: filter.isExport,
    };
    return requestData;
  };

  const fetchReportData = (request) => {
    const finalRequest = request || formRequestObject();
    props.getDataListing(finalRequest);
  };

  const getData = (page) => {
    setCurrentPageNo(page);
    fetchReportData({ ...formRequestObject(), pageNo: page });
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);
    fetchReportData({ ...formRequestObject(), pageNo: 0, pageSize });
  };

  const searchChanged = (text) => setSearchText(text);

  const Download = () => props.downloadJob({ ...formRequestObject(), isExport: true });

  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const handleResetFilters = (resetForm) => {
    resetForm();
    setFilter({
      distributor: [],
      distCenter: [],
      fromDate: new Date(),
      toDate: new Date(),
      pageNo: 0,
      searchText: searchText,
      isExport: false,
    });
    setDistCentersOptions([]);
  };

  const applyFilters = () => {
    setCurrentPageNo(0);
    fetchReportData({ ...formRequestObject(), pageNo: 0 });
    setShow(false);
  };

  // -------------------- JSX -------------------- //
  return (
    <VzPageContainer title="Bank-wise Deposit Report">
      <Row>
        <Col md={{ span: 10 }}>
          <h4>
            <b>Bank-wise Deposit Report</b>
          </h4>
        </Col>
      </Row>

      {/* Filters & Export */}
      <Row>
        <Col md={10}>
          <div ref={ref}>
            <Button onClick={openFilterModal} className="m-3" variant="outline-primary">
              <i className="fa fa-filter" /> Filters
            </Button>

            <Overlay
              show={show}
              target={target}
              placement="bottom"
              container={ref}
              containerPadding={20}
            >
              <Popover id="popover-contained" style={{ maxWidth: "360px", width: "360px" }}>
                <Popover.Header as="h3">Filters</Popover.Header>
                <Popover.Body>
                  <Formik enableReinitialize initialValues={filter} onSubmit={applyFilters}>
                    {(formik) => (
                      <Form autoComplete="off">
                        <Row>
                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="react-select"
                              label="Distributor Name"
                              name="distributorName"
                              options={addJobDistributorsOptions}
                              isMulti={true}
                              isClearable={true}
                              isSearchable={true}
                              handleOnChange={(e) => {
                                setFilter({
                                  ...filter,
                                  distributor: e || [],
                                  distCenter: []
                                });
                              }}
                              value={filter.distributor}
                            />
                          </Col>

                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="react-select"
                              label="Distribution ID"
                              name="distributionID"
                              options={distCentersOptions}
                              isMulti={true}
                              isClearable={true}
                              isSearchable={true}
                              handleOnChange={(e) => {
                                setFilter({
                                  ...filter,
                                  distCenter: e || [],
                                });
                              }}
                              value={filter.distCenter}
                            />
                          </Col>

                          <Col xs={12} md={6}>
                            <FormikControl
                              control="date"
                              label="From Date"
                              name="fromDate"
                              handleOnChange={(value) => setFilter({ ...filter, fromDate: value })}
                              value={filter.fromDate}
                            />
                          </Col>
                          <Col xs={12} md={6}>
                            <FormikControl
                              control="date"
                              label="To Date"
                              name="toDate"
                              handleOnChange={(value) => setFilter({ ...filter, toDate: value })}
                              value={filter.toDate}
                            />
                          </Col>
                        </Row>

                        <div className="row mt-3">
                          <div className="form-group w-100">
                            <Link onClick={() => handleResetFilters(formik.resetForm)} to="#" style={{ float: "left" }}>Reset</Link>
                            <Link onClick={() => setShow(false)} to="#" style={{ float: "right" }}>Cancel</Link>
                            <div className="float-right">
                              <Button type="submit" className="btn btn-primary" style={{ marginRight: 10 }}>Apply</Button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Popover.Body>
              </Popover>
            </Overlay>
          </div>
        </Col>

        {isPermittedPage("Export", props.actions, props.userRole) && (
          <Col md={2} style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={Download} className="m-3" variant="outline-primary">
              <i className="fa fa-download me-1" /> Export
            </Button>
          </Col>
        )}
      </Row>

      {/* DataTable */}
      <Row>
        <Col xs={12}>
          <ServerSideDataTable
            data={props.BankWiseDepositReport?.data || []}
            columns={columns}
            totalRecords={props.BankWiseDepositReport?.totalRecords || 0}
            goToPreviousPage={getData}
            goToNextPage={getData}
            pageSizeChange={pageSizeChanged}
            myPageSize={currentPageSize}
            pageNo={currentPageNo}
            searchChanged={searchChanged}
          />
        </Col>
      </Row>
    </VzPageContainer>
  );
};
const mapStateToProps = (state) => ({
  allDistributorList: state.ddlList.allDistributorList || [],
  selectedAddJobDistCentersList: state.ddlList.selectedAddJobDistCentersList || [],
  BankWiseDepositReport: state.BankWiseDepositReport,
  userRole: storage.get("_appUserRole"),
});

export default connect(mapStateToProps, {
  getDropdownList,
  getDropdownListByPost,
  getDataListing,
  downloadJob,
})(BankWiseDepositReport);
